// extracted by mini-css-extract-plugin
export default {"container":"Container_container__Zm77Y","narrow":"Container_narrow__+RYBq"};